import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const TarifsPage = lazy(() => import('../pages/tarifs/page'));
const AProposPage = lazy(() => import('../pages/a-propos/page'));
const ActualitesPage = lazy(() => import('../pages/actualites/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/tarifs',
    element: <TarifsPage />,
  },
  {
    path: '/a-propos',
    element: <AProposPage />,
  },
  {
    path: '/actualites',
    element: <ActualitesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
